import AsyncComponentLoading from 'email-management-lib/refactor/components/app/asyncLoaders/AsyncComponentLoading';
import Loadable from 'UIComponents/decorators/Loadable';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncProbationBannerContainer = Loadable({
  loader: () => import( /* webpackChunkName: "probation-banner" */'email-health-ui-lib/probation/containers/ProbationBannerContainer'),
  LoadingComponent: props => /*#__PURE__*/_jsx(AsyncComponentLoading, Object.assign({}, props, {
    bundleName: "probation-banner",
    useSpinner: false
  })),
  ErrorComponent: props => /*#__PURE__*/_jsx(AsyncComponentLoading, Object.assign({}, props, {
    bundleName: "probation-banner",
    navMarkerErrorName: "PROBATION_BANNER_LOAD_FAILED",
    useSpinner: false
  }))
});
export default AsyncProbationBannerContainer;